import api from '../..'
import { IAnswerLikertModel } from 'models/answerLikert.model'

const answerLikertEdit = (answerLikert: IAnswerLikertModel) => {
  const { id } = answerLikert
  return api.put(`answers/likerts/${id}`, answerLikert)
}

export default answerLikertEdit
